export default "__VITE_ASSET__8b06a77d__"